import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class WingsBadge extends WritingBadge {
  public readonly id = BadgeId.wings;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.pagesCount >= 99;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/wings.ts